// extracted by mini-css-extract-plugin
module.exports = {"endedDuelDisplay":"EndedDuelDisplay_endedDuelDisplay__2rikK","lost":"EndedDuelDisplay_lost__17La1"};